import { Select, SelectProps } from 'antd';

interface Props {
  label: string;
  rootStyle?: React.CSSProperties;
  onChangeInput: (value: string | string[]) => void;
  required?: boolean;
  options: {
    label: string;
    value: string;
  }[]
}

export default function KFMultiSelect({ placeholder, onChangeInput, rootStyle, style, options, ...rest }: Props & SelectProps) {
  return (
    <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", rowGap: 5, ...rootStyle }} >
      <Select
        mode="multiple"
        style={{ width: '100%', height: 44, color: "black", ...style }}
        placeholder={placeholder}
        options={options}
        onChange={(v) => onChangeInput(v)}
        {...rest}
      />
    </div>
  )
}
